// extracted by mini-css-extract-plugin
export var body = "storyCarouselCard-module--body--07160";
export var content = "storyCarouselCard-module--content--370f2";
export var image = "storyCarouselCard-module--image--93c34";
export var storyCarouselCard = "storyCarouselCard-module--story-carousel-card--8612d";
export var title = "storyCarouselCard-module--title--3831e";